import logoUrl from '@/assets/hcd-logo.png'
import { cn } from '@/lib/utils'

/** The full HCD Cleaning logo (for light surfaces). */
export function Logo({ className }: { className?: string }) {
  return <img src={logoUrl} alt="HCD Cleaning" className={cn('h-10 w-auto', className)} />
}

/**
 * Compact mark drawn from the logo: the swoosh and sparkle. Uses currentColor
 * for the swoosh so it works on the navy sidebar and on light surfaces.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" aria-hidden="true" className={cn('size-8', className)}>
      {/* Outer crescent (currentColor), inner rinse crescent and sparkle, after the HCD logo. */}
      <path
        d="M33 5.5C17.5 5 5 15.5 5 29.5c0 2.2.3 4.2.9 6C8.2 20.5 19 10.2 33 9.4Z"
        fill="currentColor"
      />
      <path
        d="M3.4 22.6C1.2 30.8 5.3 37.6 13.6 38.8 7.2 35.4 3.9 29.8 3.4 22.6Z"
        fill="var(--rinse)"
      />
      <path
        d="M31.5 0.8l1.1 4.3 4.3 1.1-4.3 1.1-1.1 4.3-1.1-4.3-4.3-1.1 4.3-1.1z"
        fill="var(--rinse)"
      />
    </svg>
  )
}

/** The brand swoosh arc, the one expressive element in the interface. */
export function Swoosh({ className, animate = false }: { className?: string; animate?: boolean }) {
  return (
    <svg viewBox="0 0 600 600" aria-hidden="true" className={className} fill="none">
      <path
        d="M560 60C300 70 70 240 70 560"
        stroke="var(--rinse)"
        strokeWidth="46"
        strokeLinecap="round"
        pathLength={1}
        className={animate ? 'swoosh-draw' : undefined}
      />
      <path
        d="M520 120C320 140 150 300 150 560"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="18"
        strokeLinecap="round"
        pathLength={1}
        className={animate ? 'swoosh-draw swoosh-delay' : undefined}
      />
    </svg>
  )
}
